import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import { Grid, Select, MenuItem, FormControl, InputLabel, Button, Divider, Typography, FormControlLabel, Checkbox } from '@material-ui/core'
import * as utils from '@utils'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import Search from '@material-ui/icons/Search'
import { CompleteDecimal } from '@select'
import { Table } from '@tables'
import { Decimal } from 'decimal.js'

const COMPONENT_GROUP = 'transfer_record'

class TransferRecordPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'TransferRecordPage')
        }
    }

    state = {
        date: utils.currentDatetime(),
        pfId: '',
        pfList: [],
        transferWallet: true,
        singleWallet: true,
    }

    pfSubPfMap = {}
    columns = [
        {
            field: 'date'
        },
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'withdraw_count',
            type: 'numberByThous'
        },
        {
            field: 'deposit_count',
            type: 'numberByThous'
        },
        {
            field: 'currency',
            render: (row) => {
                return utils.t(`Currency.${row['currency']}`)
            },
        },
        {
            field: 'withdraw_amount',
            type: 'currency'
        },
        {
            field: 'deposit_amount',
            type: 'currency'
        }
    ]
    options = {
        export: false,
        search: false
    }

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
        this.handleGetPfSubPfMap()
    }

    handleGetPfSubPfMap() {
        this.pfSubPfMap = utils.deepCopy(this.props.dataService.pfSubPfMap)
        const pfList = [] // 整理幣別(站台)類別
        Object.entries(this.pfSubPfMap).forEach(([pfSubPfId, elem]) => {
            if (!this.props.auth.isSuperUser && pfSubPfId === 'ze_ze') return
            if (!pfList.includes(elem.pf_id)) pfList.push(elem.pf_id)
        })

        const sortPfList = utils.sortPlatform(pfList) // 幣別(站台)排序

        this.setState(
            {
                pfList: sortPfList,
                pfId: sortPfList[0]
            }
        )
    }

    formatPlatformData(data) {
        let tempList = []
        try {
            let count = 0
            data.forEach((elem) => {
                const detail = utils.deepCopy(elem)
                const countList = ['deposit_amount', 'deposit_count', 'withdraw_amount', 'withdraw_count']
                countList.forEach(key => {
                    detail[key] = !detail[key] ? 0 : Number(detail[key])
                })
                detail['pf_sub_pf_id'] = detail['sub_pf_id']
                detail['currency'] = utils.getPfCurrency(this.state.pfId)
                delete detail['sub_pf_id']
                tempList.push(detail)
            })
            const sumPerDay = {}
            tempList.forEach((item) => {
                if (sumPerDay[item.date] === undefined) {
                    sumPerDay[item.date] = {
                        ...item,
                        id: ++count,
                        pf_sub_pf_id: 'all',
                        currency: utils.getPfCurrency(this.state.pfId)
                    }
                } else {
                    Object.keys(sumPerDay[item.date]).forEach((key) => {
                        if (!['id', 'date', 'pf_sub_pf_id', 'currency'].includes(key)){
                            sumPerDay[item.date][key] = new Decimal(sumPerDay[item.date][key]).add(item[key])
                        }
                    })
                }
                item.id = ++count
                item.parent = sumPerDay[item.date].id
            })
            tempList = tempList.concat(Object.values(sumPerDay))
        } catch(error) {
            console.log(error)
        }

        return tempList
    }

    queryData = () => {
        this.sumTable.SetLoading(true)
        this.transferTable.SetLoading(true)
        this.singleTable.SetLoading(true)

        const queryParams = {
            start_time: utils.datetimeToUnix_startOf(this.state.date, 'day'),
            end_time: utils.datetimeToUnix_endOf(this.state.date, 'day'),
            pf_id: this.state.pfId !== 'all' ? this.state.pfId : '',
        }

        utils.apiRequest(
            'get',
            API.TRANSFER_RECORD_SUMMARY,
            queryParams,
            (data) => {
                const { single, total, transfer } = data
                const sumTableData = total ? this.formatPlatformData(total) : []
                const transferTableData = transfer ? this.formatPlatformData(transfer) : []
                const singleTableData = single ? this.formatPlatformData(single) : []

                const currency = utils.getPfCurrency(queryParams['pf_id'])
                this.sumTable.SetData(sumTableData, currency)
                this.transferTable.SetData(transferTableData, currency)
                this.singleTable.SetData(singleTableData, currency)
            },
            (_err) => {
                this.sumTable.SetData([])
                this.transferTable.SetData([])
                this.singleTable.SetData([])
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                        className={this.props.classes.textField}
                        variant="inline"
                        value={this.state.date}
                        onChange={(date) => {
                            this.setState({
                                date: date
                            })
                        }}
                        format={'yyyy/MM/dd'}
                        openTo={'date'}
                        views={['year', 'month', 'date']}
                        label={this.t('searchDate')}
                    />
                </MuiPickersUtilsProvider>
                <FormControl className={this.props.classes.formControl}>
                    <InputLabel htmlFor="age-simple">{this.t('platform')}</InputLabel>
                    <Select
                        value={this.state.pfId}
                        onChange={(event) => {
                            this.setState({
                                pfId: event.target.value,
                            })
                        }}>
                        {/* <MenuItem value="all">
                            {this.t('allPlatform')}
                        </MenuItem> */}
                        {this.state.pfList.map((key) => (
                            <MenuItem value={key} key={key}>
                                {`${this.t('Platform.' + key)} (${this.t('Currency.' + utils.getPfCurrency(key))})`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <Grid item>
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.transferWallet}
                                onChange={(event) => {
                                    this.setState({
                                        transferWallet: event.target.checked,
                                    })
                                }}
                                color="primary"
                            />
                        }
                        label={this.t('showTransferWallet')}
                    />
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.singleWallet}
                                onChange={(event) => {
                                    this.setState({
                                        singleWallet: event.target.checked,
                                    })
                                }}
                                color="primary"
                            />
                        }
                        label={this.t('showSingleWallet')}
                    />
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <CompleteDecimal />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">{this.t('total')}</Typography>
                    <Table
                        ownerName="TransferRecordPage"
                        columns={this.columns}
                        options={this.options}
                        noData={this.t('noData')}
                        onRef={(ref) => (this.sumTable = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
                <Grid item xs={12} className={this.state.transferWallet ? '' : this.props.classes.hide}>
                    <Divider />
                </Grid>
                <Grid item xs={12} className={this.state.transferWallet ? '' : this.props.classes.hide}>
                    <Typography variant="h6">{this.t('transferWallet')}</Typography>
                    <Table
                        ownerName="TransferRecordPage"
                        columns={this.columns}
                        options={this.options}
                        noData={this.t('noData')}
                        onRef={(ref) => (this.transferTable = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
                <Grid item xs={12} className={this.state.singleWallet ? '' : this.props.classes.hide}>
                    <Divider />
                </Grid>
                <Grid item xs={12} className={this.state.singleWallet ? '' : this.props.classes.hide}>
                    <Typography variant="h6">{this.t('singleWallet')}</Typography>
                    <Table
                        ownerName="TransferRecordPage"
                        columns={this.columns}
                        options={this.options}
                        noData={this.t('noData')}
                        onRef={(ref) => (this.singleTable = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
            '& label': {
                marginBottom: 0,
            }
        },
        hide: {
            display: 'none',
        },
    }
}

TransferRecordPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    datepart: PropTypes.string,
}

export default hoc(styles)(TransferRecordPage)
